import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type DividerProps = ComponentProps<typeof Divider>;

export const Divider = styled("hr", {
  // Reset
  boxSizing: "border-box",

  // Custom
  margin: 0,
  border: "none",

  variants: {
    orientation: {
      horizontal: {
        height: 0,
        width: "100%",
        borderBottom: "1px solid",
        borderBottomColor: "$neutral-200",
      },
      vertical: {
        width: 0,
        height: "auto",
        alignSelf: "stretch",
        flexShrink: 0,
        borderRight: "1px solid",
        borderRightColor: "$neutral-200",
      },
    },
    variant: {
      white: {
        borderBottomColor: "$neutrals-white",
        borderRightColor: "$neutrals-white",
      },
      neutral: {
        borderBottomColor: "rgba(17, 17, 17, 0.15)",
        borderRightColor: "rgba(17, 17, 17, 0.15)",
      },
      "neutral-300": {
        borderBottomColor: "$neutral-300",
        borderRightColor: "$neutral-300",
      },
      "neutral-400": {
        borderBottomColor: "$neutral-400",
        borderRightColor: "$neutral-400",
      },
      "primary-600": {
        borderBottomColor: "$primary-600",
        borderRightColor: "$primary-600",
      },
    },
  },

  defaultVariants: {
    orientation: "horizontal",
  },
});
